import { Controller } from 'react-hook-form'
import FieldLabel from '../field-label'
import FiledCheckbox from '../field-checkbox'

const normalizeSelectedValues = (value) => {
    if (Array.isArray(value)) {
        return value
    }

    if (value === undefined || value === null || value === '') {
        return []
    }

    return [value]
}

const isSameValue = (a, b) => String(a) === String(b)

function FieldCheckboxGroup(props) {
    const {
        TITLE: label,
        UF_VALUE_LIST = [],
        UF_MULTIPLICITY = false,
        name,
        control,
        validation = {},
        required,
        labelMark,
    } = props

    const isMultiple = UF_MULTIPLICITY

    // Переключение значения: множественный выбор или radio-поведение
    const getNextValue = (selectedValues, optionValue) => {
        const isSelected = selectedValues.some((value) => isSameValue(value, optionValue))

        if (isMultiple) {
            return isSelected
                ? selectedValues.filter((value) => !isSameValue(value, optionValue))
                : [...selectedValues, optionValue]
        }

        return isSelected ? [] : [optionValue]
    }

    const { required: requiredMessage, validate: customValidate, ...restValidation } = validation

    const groupRules = {
        ...restValidation,
        validate: {
            ...(typeof customValidate === 'object' ? customValidate : {}),
            ...(requiredMessage && {
                required: (value) => {
                    const selected = normalizeSelectedValues(value)
                    return selected.length > 0 || requiredMessage
                },
            }),
        },
    }

    return (
        <>
            {label && (
                <FieldLabel label={label} required={required || validation.required} labelMark={labelMark} />
            )}
            <Controller
                control={control}
                name={name}
                defaultValue={[]}
                rules={groupRules}
                render={({ field: { onChange, value } }) => {
                    const selectedValues = normalizeSelectedValues(value)

                    const handleToggle = (optionValue) => {
                        onChange(getNextValue(selectedValues, optionValue))
                    }

                    return (
                        <div className="field__multiple-list" role="group" aria-label={label}>
                            <div className="field__multiple-list-grid">
                                {UF_VALUE_LIST.map((option) => {
                                    const optionValue = option?.ID ?? option
                                    const optionText = option?.NAME ?? option
                                    const isChecked = selectedValues.some((value) =>
                                        isSameValue(value, optionValue)
                                    )

                                    return (
                                        <div className="field__multiple-list-item" key={optionValue}>
                                            <FiledCheckbox
                                                checked={isChecked}
                                                onChange={() => handleToggle(optionValue)}
                                                text={optionText}
                                                aria-label={optionText}
                                            />
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    )
                }}
            />
        </>
    )
}

export default FieldCheckboxGroup
